import React from 'react';
import { createContext } from 'react';

export const StyleContext = createContext({} as { isLuxury: boolean; setIsLuxury: React.Dispatch<React.SetStateAction<boolean>>; });